export function displaySmartScheduler(orgaId: string): boolean {
    const blackListSmartSchedulerOrgaIds = import.meta.env.VITE_SMART_SCHEDULER_BLACKLIST_ORGA_IDS;

    if (blackListSmartSchedulerOrgaIds) {
        const blackListSmartSchedulerOrgaIdsList = blackListSmartSchedulerOrgaIds.split(";");

        if (blackListSmartSchedulerOrgaIdsList.includes(orgaId)) {
            return false;
        }
        return true;
    }
    return true;
}
